/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initDrawers() {
  const drawers = Array.from(document.querySelectorAll('dialog.drawer'))
  const main = document.querySelector('main.layout') as HTMLElement

  const observer = new MutationObserver(function (event) {
    if (event[0].attributeName === 'open') {
      if (event[0].target instanceof HTMLDialogElement) {
        if (event[0].target.open) {
          event[0].target.dispatchEvent(new CustomEvent('open'))
        }
      }
    }
  })

  for (const drawer of drawers) {
    if (!(drawer instanceof HTMLDialogElement)) {
      continue
    }
    if (drawer.dataset.hydrated) continue
    drawer.dataset.hydrated = 'true'
    observer.observe(drawer, { attributes: true })

    drawer.addEventListener('close', () => {
      if (Array.from(document.querySelectorAll('dialog:modal')).length === 0) {
      }

      if (main?.inert) {
        main.inert = false
      }
    })

    drawer.addEventListener('open', () => {
      const handleClose = (e: PointerEvent) => {
        if (e.target === drawer) {
          drawer.close()
          document.removeEventListener('click', handleClose)
        }
      }

      document.addEventListener('click', handleClose)
    })

    drawer.addEventListener('command', (e) => {
      // @ts-ignore: api is not typed yet?
      if (e.command === '--show') {
        drawer.show()

        if (main) {
          main.inert = true
        }

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            drawer.close()
          }
        }, { once: true })
      }
    })
  }
}
